'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var _typeof = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? function (obj) {
    return typeof obj;
} : function (obj) {
    return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
};
var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor)
                descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
var Danmaku = function () {
    function Danmaku(options) {
        _classCallCheck(this, Danmaku);
        this.options = options;
        this.container = this.options.container;
        this.danTunnel = {
            right: {},
            top: {},
            bottom: {}
        };
        this.danIndex = 0;
        this.dan = [];
        this.showing = true;
        this._opacity = this.options.opacity;
        this.events = this.options.events;
        this.unlimited = this.options.unlimited;
        this.danmu_list = new Array();
        this._measure('');
        this.load();
        this.shield_list = new Array();
        this.options.danmu_pool.danmaki_add_shield.addEventListener('click', this.add_shield.bind(this));
    }
    _createClass(Danmaku, [
        {
            key: 'load',
            value: function load() {
                var _this = this;
                var apiurl = void 0;
                apiurl = this.options.api.address + '?m=mukio&c=index&a=init&playerID=' + this.options.api.id;
                var endpoints = (this.options.api.addition || []).slice(0);
                endpoints.push(apiurl);
                this.events && this.events.trigger('danmaku_load_start', endpoints);
                this._readAllEndpoints(endpoints, function (results) {
                    _this.dan = [].concat.apply([], results).sort(function (a, b) {
                        return a.time - b.time;
                    });
                    window.requestAnimationFrame(function () {
                        _this.frame();
                    });
                    if (_this.options.api_callback) {
                        _this.danmu_list = _this.dan;
                        _this.draw_danmaku_pool();
                        document.querySelector('#sort-time').addEventListener('click', _this.Time_sorting.bind(_this));
                        document.querySelector('#sort-crtime').addEventListener('click', _this.crTime_sorting.bind(_this));
                        _this.options.api_callback(_this.dan);
                    }
                    _this.options.callback();
                    _this.events && _this.events.trigger('danmaku_load_end');
                });
            }
        },
        {
            key: 'reload',
            value: function reload(newAPI) {
                this.options.api = newAPI;
                this.dan = [];
                this.clear();
                this.load();
            }
        },
        {
            key: '_readAllEndpoints',
            value: function _readAllEndpoints(endpoints, callback) {
                var _this2 = this;
                var results = [];
                var readCount = 0;
                var cbk = function cbk(i) {
                    return function (err, data) {
                        ++readCount;
                        if (err) {
                            if (err.response) {
                                _this2.options.error(err.response.msg);
                            } else {
                                _this2.options.error('Request was unsuccessful: ' + err.status);
                            }
                            results[i] = [];
                        } else {
                            var typeMap = [
                                'right',
                                'right',
                                'top',
                                'bottom'
                            ];
                            if (data) {
                                results[i] = data.map(function (item) {
                                    return {
                                        time: item[0],
                                        type: typeMap[item[1]] || typeMap[1],
                                        color: item[2],
                                        author: item[3],
                                        message: item[4],
                                        addtime: item[5]
                                    };
                                });
                            } else {
                                results[i] = [];
                            }
                        }
                        if (readCount === endpoints.length) {
                            return callback(results);
                        }
                    };
                };
                for (var i = 0; i < endpoints.length; ++i) {
                    this.options.apiBackend.read(endpoints[i], cbk(i));
                }
            }
        },
        {
            key: 'send',
            value: function send(dan, callback) {
                switch (dan.type) {
                case 'right':
                    dan.type = 1;
                    break;
                case 'top':
                    dan.type = 2;
                    break;
                case 'bottom':
                    dan.type = 3;
                    break;
                default:
                    dan.type = 1;
                    break;
                }
                var color = dan.color.replace('#', '');
                var danmakuData = {
                    message: dan.message,
                    color: parseInt(color, 16),
                    stime: this.options.time(),
                    addtime: Date.parse(new Date()) / 1000,
                    token: this.options.api.token,
                    cid: this.options.api.id,
                    mode: dan.type,
                    size: 25,
                    user: this.options.api.user,
                    datatype: 'send'
                };
                this.options.apiBackend.send(this.options.api.address + '?m=mukio&c=index&a=post&playerID=' + this.options.api.id, danmakuData, callback);
                var danmaku_item = {
                    time: danmakuData.stime,
                    type: dan.type,
                    color: color,
                    author: 'smith',
                    message: dan.message,
                    addtime: danmakuData.addtime
                };
                this.dan.splice(this.danIndex, 0, danmaku_item);
                this.danIndex++;
                if (this.options.api_callback) {
                    this.danmu_list = this.dan;
                    this.draw_danmaku_pool();
                    this.options.api_callback(this.dan);
                }
                var danmaku = {
                    message: this.htmlEncode(dan.message),
                    color: '#' + color,
                    type: danmakuData.type,
                    border: '2px solid ' + this.options.borderColor
                };
                this.draw(danmaku);
                this.events && this.events.trigger('danmaku_send', danmakuData);
            }
        },
        {
            key: 'frame',
            value: function frame() {
                var _this3 = this;
                if (this.dan.length && !this.paused && this.showing) {
                    var item = this.dan[this.danIndex];
                    var dan = [];
                    while (item && this.options.time() > parseFloat(item.time)) {
                        dan.push(item);
                        item = this.dan[++this.danIndex];
                    }
                    this.draw(dan);
                }
                window.requestAnimationFrame(function () {
                    _this3.frame();
                });
            }
        },
        {
            key: 'opacity',
            value: function opacity(percentage) {
                if (percentage !== undefined) {
                    var items = this.container.getElementsByClassName('dplayer-danmaku-item');
                    for (var i = 0; i < items.length; i++) {
                        items[i].style.opacity = percentage;
                    }
                    this._opacity = percentage;
                    this.events && this.events.trigger('danmaku_opacity', this._opacity);
                }
                return this._opacity;
            }
        },
        {
            key: 'draw',
            value: function draw(dan) {
                var _this4 = this;
                if (this.showing) {
                    var itemHeight = this.options.height;
                    var danWidth = this.container.offsetWidth;
                    var danHeight = this.container.offsetHeight;
                    var itemY = parseInt(danHeight / itemHeight);
                    var danItemRight = function danItemRight(ele) {
                        var eleWidth = ele.offsetWidth || parseInt(ele.style.width);
                        var eleRight = ele.getBoundingClientRect().right || _this4.container.getBoundingClientRect().right + eleWidth;
                        return _this4.container.getBoundingClientRect().right - eleRight;
                    };
                    var danSpeed = function danSpeed(width) {
                        return (danWidth + width) / 5;
                    };
                    var getTunnel = function getTunnel(ele, type, width) {
                        var tmp = danWidth / danSpeed(width);
                        var _loop = function _loop(i) {
                            var item = _this4.danTunnel[type][i + ''];
                            if (item && item.length) {
                                if (type !== 'right') {
                                    return 'continue';
                                }
                                for (var j = 0; j < item.length; j++) {
                                    var danRight = danItemRight(item[j]) - 10;
                                    if (danRight <= danWidth - tmp * danSpeed(parseInt(item[j].style.width)) || danRight <= 0) {
                                        break;
                                    }
                                    if (j === item.length - 1) {
                                        _this4.danTunnel[type][i + ''].push(ele);
                                        ele.addEventListener('animationend', function () {
                                            _this4.danTunnel[type][i + ''].splice(0, 1);
                                        });
                                        return { v: i % itemY };
                                    }
                                }
                            } else {
                                _this4.danTunnel[type][i + ''] = [ele];
                                ele.addEventListener('animationend', function () {
                                    _this4.danTunnel[type][i + ''].splice(0, 1);
                                });
                                return { v: i % itemY };
                            }
                        };
                        for (var i = 0; _this4.unlimited || i < itemY; i++) {
                            var _ret = _loop(i);
                            switch (_ret) {
                            case 'continue':
                                continue;
                            default:
                                if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === 'object')
                                    return _ret.v;
                            }
                        }
                        return -1;
                    };
                    if (Object.prototype.toString.call(dan) !== '[object Array]') {
                        dan = [dan];
                    }
                    var docFragment = document.createDocumentFragment();
                    var _loop2 = function _loop2(i) {
                        if (!dan[i].type) {
                            dan[i].type = 'right';
                        }
                        if (!dan[i].color) {
                            dan[i].color = '#fff';
                        }
                        var item = document.createElement('div');
                        item.classList.add('dplayer-danmaku-item');
                        item.classList.add('dplayer-danmaku-' + dan[i].type);
                        if (dan[i].border) {
                            item.innerHTML = '<span style="border:' + dan[i].border + '">' + dan[i].message + '</span>';
                        } else {
                            item.innerHTML = dan[i].message;
                        }
                        item.style.opacity = _this4._opacity;
                        item.style.color = dan[i].color;
                        item.addEventListener('animationend', function () {
                            _this4.container.removeChild(item);
                        });
                        var itemWidth = _this4._measure(dan[i].message);
                        var tunnel = void 0;
                        switch (dan[i].type) {
                        case 'right':
                            tunnel = getTunnel(item, dan[i].type, itemWidth);
                            if (tunnel >= 0) {
                                item.style.width = itemWidth + 1 + 'px';
                                item.style.top = itemHeight * tunnel + 'px';
                                item.style.transform = 'translateX(-' + danWidth + 'px)';
                            }
                            break;
                        case 'top':
                            tunnel = getTunnel(item, dan[i].type);
                            if (tunnel >= 0) {
                                item.style.top = itemHeight * tunnel + 'px';
                            }
                            break;
                        case 'bottom':
                            tunnel = getTunnel(item, dan[i].type);
                            if (tunnel >= 0) {
                                item.style.bottom = itemHeight * tunnel + 'px';
                            }
                            break;
                        default:
                            console.error('Can\'t handled danmaku type: ' + dan[i].type);
                        }
                        if (tunnel >= 0) {
                            item.classList.add('dplayer-danmaku-move');
                            docFragment.appendChild(item);
                        }
                    };
                    for (var i = 0; i < dan.length; i++) {
                        _loop2(i);
                    }
                    this.container.appendChild(docFragment);
                    return docFragment;
                }
            }
        },
        {
            key: 'play',
            value: function play() {
                this.paused = false;
            }
        },
        {
            key: 'pause',
            value: function pause() {
                this.paused = true;
            }
        },
        {
            key: '_measure',
            value: function _measure(message) {
                if (!this.context) {
                    var measureStyle = getComputedStyle(this.container.getElementsByClassName('dplayer-danmaku-item')[0], null);
                    this.context = document.createElement('canvas').getContext('2d');
                    this.context.font = measureStyle.getPropertyValue('font');
                }
                return this.context.measureText(message).width;
            }
        },
        {
            key: 'seek',
            value: function seek() {
                this.clear();
                for (var i = 0; i < this.dan.length; i++) {
                    if (this.dan[i].time >= this.options.time()) {
                        this.danIndex = i;
                        break;
                    }
                    this.danIndex = this.dan.length;
                }
            }
        },
        {
            key: 'clear',
            value: function clear() {
                this.danTunnel = {
                    right: {},
                    top: {},
                    bottom: {}
                };
                this.danIndex = 0;
                this.options.container.innerHTML = '';
                this.events && this.events.trigger('danmaku_clear');
            }
        },
        {
            key: 'htmlEncode',
            value: function htmlEncode(str) {
                return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;').replace(/\//g, '&#x2f;');
            }
        },
        {
            key: 'resize',
            value: function resize() {
                var danWidth = this.container.offsetWidth;
                var items = this.container.getElementsByClassName('dplayer-danmaku-item');
                for (var i = 0; i < items.length; i++) {
                    items[i].style.transform = 'translateX(-' + danWidth + 'px)';
                }
            }
        },
        {
            key: 'hide',
            value: function hide() {
                this.showing = false;
                this.pause();
                this.clear();
                this.events && this.events.trigger('danmaku_hide');
            }
        },
        {
            key: 'show',
            value: function show() {
                this.seek();
                this.showing = true;
                this.play();
                this.events && this.events.trigger('danmaku_show');
            }
        },
        {
            key: 'unlimit',
            value: function unlimit(boolean) {
                this.unlimited = boolean;
            }
        },
        {
            key: 'chg_time',
            value: function chg_time(date, mat) {
                Date.prototype.format = function (format) {
                    var date = {
                        'M+': this.getMonth() + 1,
                        'd+': this.getDate(),
                        'h+': this.getHours(),
                        'm+': this.getMinutes(),
                        's+': this.getSeconds(),
                        'q+': Math.floor((this.getMonth() + 3) / 3),
                        'S+': this.getMilliseconds()
                    };
                    if (/(y+)/i.test(format)) {
                        format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
                    }
                    for (var k in date) {
                        if (new RegExp('(' + k + ')').test(format)) {
                            format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? date[k] : ('00' + date[k]).substr(('' + date[k]).length));
                        }
                    }
                    return format;
                };
                var newdate = new Date(date * 1000);
                return newdate.format(mat);
            }
        },
        {
            key: 'draw_danmaku_pool',
            value: function draw_danmaku_pool() {
                var danmu_pool = document.querySelector('.danmu_pool ul.contents');
                danmu_pool.innerHTML = '';
                for (var abc = 0; abc < this.danmu_list.length; abc++) {
                    var dan_row = document.createElement('li');
                    var dan_time = document.createElement('div');
                    var dan_text = document.createElement('div');
                    var dan_addtime = document.createElement('div');
                    dan_row.setAttribute('title', this.danmu_list[abc].message);
                    dan_time.innerText = this.chg_time(this.danmu_list[abc].time, 'hh:mm:ss');
                    dan_text.innerText = this.danmu_list[abc].message;
                    dan_addtime.innerText = this.chg_time(this.danmu_list[abc].addtime, 'MM-dd hh:mm');
                    dan_row.appendChild(dan_time);
                    dan_row.appendChild(dan_text);
                    dan_row.appendChild(dan_addtime);
                    danmu_pool.appendChild(dan_row);
                }
            }
        },
        {
            key: 'Time_sorting',
            value: function Time_sorting() {
                var type = event.target.getAttribute('data-sort');
                switch (type) {
                case 'down':
                    this.danmu_list.sort(function (a, b) {
                        return b['time'] - a['time'];
                    });
                    this.draw_danmaku_pool(this.danmu_list);
                    event.target.setAttribute('data-sort', 'up');
                    break;
                case 'up':
                    this.danmu_list.sort(function (a, b) {
                        return a['time'] - b['time'];
                    });
                    this.draw_danmaku_pool(this.danmu_list);
                    event.target.setAttribute('data-sort', 'down');
                    break;
                default:
                    this.draw_danmaku_pool(this.danmu_list);
                    break;
                }
            }
        },
        {
            key: 'crTime_sorting',
            value: function crTime_sorting() {
                var type = event.target.getAttribute('data-sort');
                switch (type) {
                case 'down':
                    this.danmu_list.sort(function (a, b) {
                        return b['addtime'] - a['addtime'];
                    });
                    this.draw_danmaku_pool(this.danmu_list);
                    event.target.setAttribute('data-sort', 'up');
                    break;
                case 'up':
                    this.danmu_list.sort(function (a, b) {
                        return a['addtime'] - b['addtime'];
                    });
                    this.draw_danmaku_pool(this.danmu_list);
                    event.target.setAttribute('data-sort', 'down');
                    break;
                default:
                    this.draw_danmaku_pool(this.danmu_list);
                    break;
                }
            }
        },
        {
            key: 'add_shield',
            value: function add_shield() {
                var a = {
                    content: document.querySelector('#shield-text').value,
                    type: document.querySelector('#shield-type').value
                };
                this.shield_list.push(a);
                document.querySelector('.danmaki-shield-table table tbody').innerHTML = '';
                for (var i = 0; i < this.shield_list.length; i++) {
                    var shield_dom = document.createElement('tr');
                    shield_dom.innerHTML = '<td class="enabled">启用</td><td class="type">' + this.shield_list[i].type + '</td><td class="contents">' + this.shield_list[i].content + '</td><td class="del">删除</td>';
                    shield_dom.querySelector('.del').addEventListener('click', this.del_shield_item.bind(this));
                    document.querySelector('.danmaki-shield-table table tbody').appendChild(shield_dom);
                }
                this.shield_start();
            }
        },
        {
            key: 'del_shield_item',
            value: function del_shield_item() {
                document.querySelector('.danmaki-shield-table table tbody td');
                event.srcElement.parentElement.parentElement.removeChild(event.srcElement.parentElement);
                var content = event.srcElement.parentElement.querySelector('.contents').innerText;
                for (var i = 0; i < this.shield_list.length; i++) {
                    if (this.shield_list[i].content == content) {
                        this.shield_list.splice(i, 1);
                    }
                }
                this.shield_start();
            }
        },
        {
            key: 'shield_start',
            value: function shield_start() {
                var danmu_lists = [].concat(this.danmu_list);
                for (var i = 0; i < danmu_lists.length; i++) {
                    for (var j = 0; j < this.shield_list.length; j++) {
                        if (this.shield_list[j].type == '文本') {
                            if (danmu_lists[i].message == this.shield_list[j].content) {
                                danmu_lists.splice(i, 1);
                            }
                        } else if (this.shield_list[j].type == '正则') {
                            var exp = new RegExp(this.shield_list[j].content);
                            if (exp.test(danmu_lists[i].message)) {
                                danmu_lists.splice(i, 1);
                            }
                        }
                    }
                }
                this.dan = danmu_lists;
            }
        }
    ]);
    return Danmaku;
}();
exports.default = Danmaku;


//////////////////
// WEBPACK FOOTER
// ./src/js/danmaku.js
// module id = 16
// module chunks = 0